import { render, staticRenderFns } from "./MyHeader.vue?vue&type=template&id=44753ed7&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"
import style0 from "./MyHeader.vue?vue&type=style&index=0&id=44753ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44753ed7",
  null
  
)

export default component.exports